import { jsx as r, jsxs as l } from "react/jsx-runtime";
import n from "classnames";
import a from "../../utils/colors.js";
import { f as c } from "../../styled-qu50FBLM.mjs";
import { Svg as f, GElement as p, Path as e } from "./Elements.js";
const x = "matrix(1,0,0,1,1,1)", h = "M6.5,0.5L6.5,12.5", u = "M0.5,6.5L12.5,6.5", S = ({
  viewBox: s = "0 0 15 15",
  className: o = "",
  fill: m = a.blueGrey,
  strokeLinecap: d = "square",
  strokeWidth: i = "2px",
  focusable: t
}) => /* @__PURE__ */ r(
  f,
  {
    className: n({ [o]: !!o }),
    viewBox: s,
    stroke: m,
    strokeLinecap: d,
    strokeWidth: i,
    $cssHelper: c,
    focusable: !!t,
    "aria-hidden": !t,
    children: /* @__PURE__ */ l(p, { transform: x, children: [
      /* @__PURE__ */ r(e, { d: h }),
      /* @__PURE__ */ r(e, { d: u })
    ] })
  }
);
export {
  S as default
};
